import script from "./WhatsAppFloat.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppFloat.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppFloat.vue?vue&type=style&index=0&id=52de1604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52de1604"]])

export default __exports__